import { useState, useCallback } from "react";
import { TextField } from "@mui/material";
import useDebouncedEffect from "$hooks/useDebounceEffect";

type DebounceProps = {
  value?: string;
  onChange: (value: any) => void;
  debounceTimeout?: number;
  type?: string;
  className?: string;
  placeholder?: string;
};

function JDebounceInput({
  value = "",
  onChange,
  debounceTimeout = 300,
  type = "text",
  ...rest
}: DebounceProps) {
  const [localValue, setLocalValue] = useState(value);

  useDebouncedEffect(
    () => {
      if (localValue !== value) {
        onChange(localValue);
      }
    },
    [localValue],
    debounceTimeout
  );

  const handleInputChange = useCallback((e: any) => {
    setLocalValue(e.target.value);
  }, []);

  return (
    <TextField
      type={type}
      value={localValue || ""}
      onChange={handleInputChange}
      {...rest}
      variant="outlined"
    />
  );
}

export default JDebounceInput;
